<div [class.scroll-wrapper]="enableScrollListener">
    <!-- this can be extended to show arrows to desired positions in future -->
    @if ((showLeft || showRight) && enableScrollListener) {
        <mat-icon class="arrow left" [class.disabled]="!showLeft" (click)="scrollLeft()" aria-hidden="true"
            >keyboard_arrow_left</mat-icon
        >
        <mat-icon class="arrow right" [class.disabled]="!showRight" (click)="scrollRight()" aria-hidden="true"
            >keyboard_arrow_right</mat-icon
        >
    }

    <div #scrollContainer [style]="styles" class="scroll-container" (scroll)="updateArrowVisibility()">
        <ng-content></ng-content>
    </div>
</div>
